<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { parseFilterParams } from '../model/filters/parse-filter-params'
import { useProbationApi } from '../api/probation.hook'
import TutorKanbanTable from './TutorKanbanTable.vue'

defineOptions({
  name: 'TutorKanbanProbationPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const params = parseFilterParams(route.query)
  void useProbationApi({ params })
})
</script>

<template>
  <TutorKanbanTable />
</template>
